import React from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Avatar,
  Box,
  CardMedia,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  styled,
  Typography,
} from "@mui/material"
import moment from "moment"
import { useParams, useNavigate } from "react-router-dom"
import { getPostById } from "../../features/posts/postSlice"
import { Favorite, Visibility } from "@mui/icons-material"
import Advertisement from "../Advertisement"

// const BoxCard = styled(Box)(({ theme }) => ({
//   display: "flex",
//   width: "100%",
//   [theme.breakpoints.down("sm")]: {
//     flexDirection: "column",
//   },
// }))
// const ImageSection = styled(Box)(({ theme }) => ({
//   marginLeft: 20,
//   [theme.breakpoints.down("sm")]: {
//     marginLeft: 0,
//   },
// }))
// const RecommendedPostsBox = styled(Stack)(({ theme }) => ({
//   direction: "row",
//   // divider:{<Divider orientation="vertical" flexItem />}
//   justifyContent: "space-around",
//   [theme.breakpoints.down("sm")]: {
//     flexDirection: "column",
//   },
// }))
const TypographyTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.8rem",
  [theme.breakpoints.up("md")]: {
    fontSize: "2.4rem",
  },
}))

const PostDetails = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { singlePost, posts, isLoading } = useSelector((state) => state.posts)

  React.useEffect(() => {
    dispatch(getPostById(id))
  }, [id, dispatch])

  if (!singlePost) return null
  if (isLoading) {
    return (
      <Paper
        elevation={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          borderRadius: "15px",
          height: "39vh",
        }}
      >
        <CircularProgress size="7em" />
      </Paper>
    )
  }

  const recommendedPosts =
    posts && Object.values(posts).filter(({ _id }) => _id !== singlePost._id)

  const openPost = (_id) => navigate(`/posts/${_id}`)

  return (
    <>
      <Box>
        <Container>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 1, sm: 2, md: 8 }}
          >
            {/* <Box flex={3} sx={{ padding: "18px 100px 100px 100px" }}> */}
            <Box flex={3}>
              <TypographyTitle
                variant="h3"
                component="h2"
                align="center"
                sx={{ fontWeight: 700, marginY: 1 }}
              >
                {singlePost.title}
              </TypographyTitle>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Divider sx={{ width: 300 }} />
              </Box>

              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                marginY={2}
              >
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Box sx={{ color: "grey" }}>
                  <Typography variant="caption">
                    By: {singlePost.name}
                  </Typography>
                  <Box>
                    <Typography variant="caption">
                      Created {moment(singlePost.createdAt).fromNow()}
                    </Typography>
                  </Box>

                  <Stack direction="row" spacing={1} alignItems="center">
                    <Visibility fontSize="small" />
                    <Typography variant="caption">
                      {singlePost.viewsCount}
                    </Typography>
                  </Stack>
                </Box>
              </Stack>

              <CardMedia
                sx={{ border: "1px solid black" }}
                component="img"
                src={`${process.env.REACT_APP_URL}${singlePost.selectedFile}`}
                alt={singlePost.title}
                loading="lazy"
              />

              <Typography variant="body1" mt={2} color="gray">
                {singlePost.message}
              </Typography>
            </Box>
            <Box flex={1}>
              <Advertisement />
            </Box>
          </Stack>
          {recommendedPosts?.length && (
            <Box>
              <Typography
                variant="h4"
                align="center"
                fontWeight="400"
                marginBottom={3}
              >
                You might also like:
              </Typography>
              <Grid container justifyContent="space-around">
                {recommendedPosts
                  .slice(0, 3)
                  .map(({ title, message, name, likes, selectedFile, _id }) => (
                    <Grid item xs={12} sm={6} md={3} key={_id}>
                      <Paper
                        elevation={6}
                        sx={{
                          cursor: "pointer",
                          // padding: 2,
                          textAlign: "center",
                          borderRadius: 15,
                          overflow: "hidden",
                        }}
                        onClick={() => openPost(_id)}
                      >
                        <Typography
                          gutterBottom
                          variant="h6"
                          fontWeight="400"
                          marginTop={2}
                        >
                          {title}
                        </Typography>

                        <Typography
                          gutterBottom
                          variant="subtitle2"
                          fontWeight="300"
                        >
                          {message}
                        </Typography>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <IconButton color="error" size="small">
                            <Favorite />
                          </IconButton>
                          <Typography variant="subtitle1" fontWeight="300">
                            {likes.length}
                          </Typography>
                        </Stack>
                        <img
                          src={`${process.env.REACT_APP_URL}${selectedFile}`}
                          alt={singlePost.title}
                          width="100%"
                          height={"200px"}
                        />
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          )}
          <Box>
            <Divider style={{ margin: "20px 0" }} />
            <Typography variant="body1">
              <strong>Comments - coming soon!</strong>
            </Typography>
            <Divider style={{ margin: "20px 0" }} />
          </Box>
        </Container>
      </Box>
    </>
  )
}
export default PostDetails
